import { Check } from "lucide-react";
import { useI18n } from "../i18n/i18n";

const PORTRAIT_IMG =
  "https://customer-assets.emergentagent.com/job_cloudship-azure/artifacts/x5ckk8ju_Business_photo_0%20copy.png";

export default function About() {
  const { t } = useI18n();
  const bullets = t("about.bullets");

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 order-2 lg:order-1">
          <p className="cs-overline mb-4">{t("about.overline")}</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white leading-tight mb-7">
            {t("about.title")}
          </h2>
          <p className="text-slate-300 leading-relaxed mb-8">{t("about.p1")}</p>

          <ul className="space-y-3">
            {bullets.map((b, i) => (
              <li
                key={i}
                className="flex items-start gap-3 text-slate-200"
                data-testid={`about-bullet-${i}`}
              >
                <span className="mt-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-sky-400/15 border border-sky-400/40">
                  <Check className="w-3 h-3 text-sky-400" />
                </span>
                <span className="text-sm">{b}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-5 order-1 lg:order-2 flex justify-center lg:justify-end">
          <div className="relative flex flex-col items-center text-center max-w-xs">
            {/* Decorative glow behind portrait */}
            <div
              aria-hidden="true"
              className="absolute -inset-6 rounded-full bg-gradient-to-br from-sky-500/15 via-transparent to-transparent blur-2xl -z-10"
            />
            <div className="relative h-56 w-56 lg:h-64 lg:w-64 rounded-full overflow-hidden border border-slate-700 ring-1 ring-sky-400/20 shadow-2xl shadow-sky-900/20">
              <img
                src={PORTRAIT_IMG}
                alt="Samer Alshreibati, Founder of Cloudship"
                className="w-full h-full object-cover"
                data-testid="about-portrait"
              />
            </div>
            <p className="font-display text-white text-lg mt-6">Samer Alshreibati</p>
            <p className="text-xs uppercase tracking-[0.22em] text-sky-400 mt-1.5">
              Founder · Senior Azure Architect
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
